import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UqualAdBannerState {
  bannerDismissed: boolean;
}

const initialState: UqualAdBannerState = {
  bannerDismissed: false,
};

const uqualAdBannerSlice = createSlice({
  name: "uqualAdBanner",
  initialState,
  reducers: {
    setUqualAdBannerDismissed(state, action: PayloadAction<boolean>) {
      state.bannerDismissed = action.payload;
    },
  },
});

export const { setUqualAdBannerDismissed } = uqualAdBannerSlice.actions;

export const selectIsUqualAdBannerDismissed = (state: { uqualAdBanner: UqualAdBannerState }) => state.uqualAdBanner.bannerDismissed;

export default uqualAdBannerSlice.reducer;
